const isAutoCompleteOptionDisabled = (option: {
  disabled?: boolean;
  beingUpdated?: boolean;
}) => Boolean(option.disabled || option.beingUpdated);

export default isAutoCompleteOptionDisabled;
